export default __webpack_public_path__ + "static/media/filter-menu.d2b4b8d8.svg";